import { useEffect, useState } from "react";
import "./announcementBar.css";

const AnnouncementBar = () => {
  const texts = [
    "Flat 20% OFF on Website & App Development – Limited Time!",
    "Free Project Consultation – Contact on +91 63066 42178"
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % texts.length);
        setFade(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="announcement-bar">
      <p className={fade ? "fade-in" : "fade-out"}>
        {texts[index]}
      </p>
    </div>
  );
};

export default AnnouncementBar;
